module.exports = __webpack_public_path__ + "static/patternBG-ba1ffd043708b4f2e4eb83c1ba76fbaa.png";